import styles from "./styles.module.scss";
import img1 from './img/img1.png'
import img2 from './img/img2.png'
import img3 from './img/img3.png'
import img4 from './img/img4.png'
import img5 from './img/img5.png'

import { IconCard } from "../../../../shared";
import { IconCardWalky } from "src/routes/onboarding/shared/components/iconCardWalky";
import { WALKY_KEYS } from "src/routes/onboarding/shared/constants/walkyKeys";

const data = [
  {
    value: "DAILY", // ?
    points: "1",
    displayValue: "Less than a year ago",
    emoji: img1,
  },
  {
    value: "DAILY",
    points: "2",
    displayValue: "1 to 2 years ago",
    emoji: img2
  },
  {
    value: "WEEKLY",
    points: "3",
    displayValue: "More than 3 years ago ",
    emoji: img3
  },
  {
    value: "MONTHLY",
    points: "4",
    displayValue: "I'm happy with my weight",
    emoji: img4
  },
  {
    value: "NEVER",
    points: "5",
    displayValue: "Never",
    emoji: img5,
    small: true,
  }
];
export const LastHappyWeight = ({ onNextStep, onTrackEvent }) => {
  const handleNextStep = (v) => {
    localStorage.setItem(WALKY_KEYS.lastHappyWeight, v.points);
    onNextStep(v.value);
    onTrackEvent?.(v.displayValue);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2>When were you last happy with your weight?</h2>
        <div className={styles.cards}>
          {data.map((value) => (
            <IconCardWalky
              onClick={() => handleNextStep(value)}
              img={value.emoji}
              title={value.displayValue}
              key={value.points}
              small={value.small}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
